import React from 'react';
import { Link } from 'react-router-dom';
import './Breadcrumb.css';

const Breadcrumb = ({ items }) => (
  <nav className="breadcrumb" aria-label="Breadcrumb">
    <ol className="breadcrumb-list">
      {items.map((item, idx) => (
        <li key={idx} className="breadcrumb-item">
          {idx < items.length - 1 ? (
            <>
              <Link className="breadcrumb-link" to={item.to || '/'}>
                {item.label}
              </Link>
              <span className="breadcrumb-sep" aria-hidden="true">/</span>
            </>
          ) : (
            <span className="breadcrumb-current" aria-current="page">{item.label}</span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

export default Breadcrumb;
